"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DateFilterDefaultValueTypes;
(function (DateFilterDefaultValueTypes) {
    DateFilterDefaultValueTypes[DateFilterDefaultValueTypes["DEFAULT"] = null] = "DEFAULT";
    DateFilterDefaultValueTypes[DateFilterDefaultValueTypes["CURRENT"] = 1] = "CURRENT";
    DateFilterDefaultValueTypes[DateFilterDefaultValueTypes["CUSTOM"] = 2] = "CUSTOM";
    DateFilterDefaultValueTypes[DateFilterDefaultValueTypes["NEXT"] = 3] = "NEXT";
    DateFilterDefaultValueTypes[DateFilterDefaultValueTypes["PREVIOUS"] = 4] = "PREVIOUS";
    DateFilterDefaultValueTypes[DateFilterDefaultValueTypes["ON_OR_AFTER"] = 5] = "ON_OR_AFTER";
    DateFilterDefaultValueTypes[DateFilterDefaultValueTypes["ON_OR_BEFORE"] = 6] = "ON_OR_BEFORE";
})(DateFilterDefaultValueTypes = exports.DateFilterDefaultValueTypes || (exports.DateFilterDefaultValueTypes = {}));
//# sourceMappingURL=date-filter-default-value-types.js.map